const ROUTES_PATH = {
  home: "/",
  templates: "/templates/",
  templatesManaged: "managed",
  templatesPublic: "public",
  templatesPrivate: "private",
  templatesShared: "shared",
  templatesfavorite: "favorite",
  templateEditor: "/template/editor/",
  templateParameter: "parameters",
  // templatesTemplateDetailsGroup: "/templates/template/details/:groupId",
  templateFolder: "folders",
  modelers: "/modelers/",
  modelerExecute: "/modeler/",  
  modeleRuns: "/modeleruns/",  
  modelerExecuteHome: "home",
  modelerExecuteHistory: "history",
  modelerExecuteGallery: "gallery",
  modelerExecuteTasks: "executions",
  modelerPostProcessing: "postprocessing",
  modelerReports: "reports",
  modelerExecuteMonitor: "monitor",
  modelersManaged: "managed",
  modelersPublic: "public",
  modelersPrivate: "private",
  modelersShared: "shared",
  modelersfavorite: "favorite", 
  marketplace: "/marketplace",
  ACCOUNT: "/account", 
  PROFILE: "/account/profile",
  ORGANIZATION: "/account/organization",
  ORGANIZATIONS: "/account/organizations",
  MEMBERS: "/account/members",
  USAGE: "/account/usage",
  BILLING: "/account/billing",
  DEPOSIT: "/account/deposit",
  error: "/error",
  SIGNIN: "/signin",
};

export default ROUTES_PATH;
